import React from 'react';

const LandingPagesPage = () => {
    return (
        <div>
            
        </div>
    );
}

export default LandingPagesPage;
